import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {isRequired, validationMixin} from '@aofl/form-validate';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../../i18n';
import {sdoNs} from '@modules/constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';

/**
 * @summary RedeemCodeForm
 * @extends {AoflElement}
 */
@customElement('redeem-code-form')
class RedeemCodeForm extends validationMixin(i18nMixin(AoflElement)) {
  @property({type: Boolean})
  submitting = false;

  @property({type: String})
  code = '';

  @property({type: Number})
  errorCode;

  @property({type: Boolean, attribute: 'for-logged-in-parent'})
  forLoggedInParent = false;

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.loggedIn`, store: storeInstance})
  loggedIn = false;

  /**
   * Creates an instance of RedeemCodeForm.
   */
  constructor() {
    super();
    this.translations = translations;

    this.validators = {
      code: {
        isRequired
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.code) {
      this.form.validate();
    }
  }

  /**
   * @readonly
   */
  static is = 'redeem-code-form';

  updateCode(e) {
    this.code = e.target.value.trim();
    this.form.code.validate();
  }

  async submit(e) {
    e.preventDefault();
    this.form.validate();
    await this.form.validateComplete;

    if (this.form.valid) {
      this.validateCode(this.code);
    }
  }

  validateCode(code) {
    this.errorCode = 0;
    this.dispatchEvent(new CustomEvent('submit', {detail: {code}}));
  }

  setErrors(error) {
    this.errorCode = error.code;
  }

  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default RedeemCodeForm;
